module.exports = __webpack_public_path__ + "static/media/ethereum_white_paper.9a1b46c9.pdf";